<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15n87vf/tc-custom/9783988269089.jpg?1704453361507" alt="This image is the cover for the book Stories from Tagore, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stories from Tagore, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Stories from Tagore is a collection of short stories written by Rabindranath Tagore, a prominent Indian poet, philosopher, and Nobel laureate. Tagore's short stories often delve into human emotions, societal issues, and philosophical themes. This collection typically includes a selection of his most compelling short stories, showcasing his literary mastery.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rabindranath Tagore
      </h2>
      
      <p class="authorDescription body article">Rabindranath Tagore, also known as Rabindranath Thakur, was a highly revered and influential Indian poet, philosopher, writer, musician, and artist. He is best known for his poetry and for composing the national anthems of India ("Jana Gana Mana") and Bangladesh ("Amar Shonar Bangla"). Tagore's contributions to literature, music, and the arts earned him international acclaim, and he became the first non-European to win the Nobel Prize in Literature in 1913.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44761950